import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  api: string = environment.url;
  server: string = environment.server;

  constructor(private httpClient: HttpClient, public router: Router) { }

  get(method: string, token: any, options?: any) {
    if (options) {
      options['headers'] = { 'x-access-tokens': token };
    } else {
      options = { headers: { 'x-access-tokens': token } };
    }

    return this.httpClient.get(this.api + method, options);
  }
  get_empty(method: string) {
    return this.httpClient.get(this.api + method);
  }

  post(method: string, body: any, token: any) {
    const requestOptions = {
      headers: { 'Content-Type': 'application/json', 'x-access-tokens': token }
    };

    return this.httpClient.post(this.api + method, JSON.stringify(body), requestOptions);
  }

  post_form(method: any, body: any, token: any) {
    const requestOptions = {
      headers: { 'x-access-tokens': token }
    };

    return this.httpClient.post(this.api + method, body, {});
  }

  post_form_update(method: any, body: any, token: any) {
    const requestOptions = {
      headers: { 'x-access-tokens': token }
    };

    return this.httpClient.patch(this.api + method, body, {});
  }

  delete(method: string, token: any) {
    const requestOptions = {
      headers: { 'Content-Type': 'application/json', 'x-access-tokens': token }
    };

    return this.httpClient.delete(this.api + method, requestOptions);
  }

  update(method: string, body: any, token: any) {
    const requestOptions = {
      headers: { 'Content-Type': 'application/json', 'x-access-tokens': token }
    };

    return this.httpClient.patch(this.api + method, JSON.stringify(body), requestOptions);
  }

  // to upload files to the server through the api
  upload(method: any, formData: FormData) {
    let type = 'multipart/form-data';
    let accept = 'application/json';

    const options = {
      headers: { 'Content-Type': type, 'Accept': accept }
    };

    return this.httpClient.post(this.api + method, formData, {});
  }

  login(body: any, method: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + btoa(body['email'] + ":" + body['password'])
      })
    };

    const loginParams = Object.keys(body).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(body[key]);
    }).join('&');

    return this.httpClient.post(this.api + method, loginParams, httpOptions);
  }

  // save the information from the JSON after login to local storage to use during the application runing 
  setToken(data: any) {
    localStorage.setItem("access_token", data['token']);
    localStorage.setItem("is_valid", 'true');
    localStorage.setItem("id", data['id']);
    localStorage.setItem("username", data['name']);
    localStorage.setItem("role", data['role']);

    this.router.navigate(['login']);
  }

  gettoken() {
    return !!localStorage.getItem("access_token");
  }

  isAllowed(roles: any) {
    let token = localStorage.getItem("access_token");
    let valid = localStorage.getItem("is_valid");

    if (token && valid)
      if (valid == 'true')
        if (this.canEnter(roles))
          return true;

    return false;
  }

  canEnter(roles: any) {
    let role = localStorage.getItem("role");

    if (role && roles.includes(role.toLowerCase()))
      return true;

    return false;
  }
}
